module.exports = __webpack_public_path__ + "img/3.c93e8648.jpg";